/**
 * Eligible zipcodes for cidara
 * Generated from CSV - DO NOT EDIT MANUALLY
 * Total zipcodes: 410
 */
export const cidaraEligibleZipCodes: readonly string[] = [
  "28024", "28074", "28114", "28722", "29301", "29302", "29303", "29304", "29305", "29306",
  "29307", "29316", "29319", "29320", "29322", "29323", "29324", "29329", "29330", "29333",
  "29334", "29336", "29338", "29340", "29341", "29342", "29346", "29348", "29349", "29353",
  "29365", "29368", "29369", "29372", "29373", "29374", "29375", "29376", "29377", "29378",
  "29385", "29386", "29388", "29395", "29650", "29651", "29652", "41011", "41012", "41014",
  "41016", "41017", "41019", "41021", "41025", "41048", "41071", "41072", "41073", "41074",
  "41075", "41076", "41085", "41099", "44021", "44022", "44023", "44024", "44026", "44040",
  "44056", "44060", "44061", "44065", "44067", "44072", "44073", "44087", "44092", "44094",
  "44095", "44096", "44097", "44101", "44102", "44103", "44104", "44105", "44106", "44107",
  "44108", "44109", "44110", "44111", "44112", "44113", "44114", "44115", "44116", "44117",
  "44118", "44119", "44120", "44121", "44122", "44123", "44124", "44125", "44126", "44127",
  "44128", "44129", "44130", "44131", "44132", "44133", "44134", "44135", "44136", "44137",
  "44139", "44141", "44142", "44143", "44144", "44146", "44147", "44181", "44188", "44190",
  "44191", "44192", "44193", "44194", "44195", "44197", "44198", "44199", "44202", "44224",
  "44233", "44234", "44236", "44237", "44241", "44255", "44264", "44286", "45001", "45002",
  "45004", "45005", "45011", "45012", "45013", "45014", "45015", "45018", "45030", "45033",
  "45034", "45036", "45039", "45040", "45041", "45042", "45044", "45050", "45051", "45052",
  "45053", "45055", "45056", "45061", "45062", "45063", "45064", "45065", "45067", "45069",
  "45071", "45111", "45122", "45140", "45147", "45150", "45152", "45174", "45201", "45202",
  "45203", "45204", "45205", "45206", "45207", "45208", "45209", "45211", "45212", "45213",
  "45214", "45215", "45216", "45217", "45218", "45219", "45220", "45221", "45222", "45223",
  "45224", "45225", "45226", "45227", "45229", "45230", "45231", "45232", "45233", "45234",
  "45235", "45236", "45237", "45238", "45239", "45240", "45241", "45242", "45243", "45244",
  "45245", "45246", "45247", "45248", "45249", "45250", "45251", "45252", "45253", "45254",
  "45255", "45258", "45262", "45263", "45264", "45267", "45268", "45269", "45270", "45271",
  "45273", "45274", "45275", "45277", "45280", "45296", "45298", "45299", "45999", "46301",
  "46302", "46304", "46307", "46308", "46319", "46340", "46341", "46342", "46345", "46346",
  "46347", "46348", "46350", "46355", "46360", "46361", "46368", "46374", "46380", "46382",
  "46383", "46384", "46385", "46390", "46391", "46392", "46393", "46401", "46402", "46403",
  "46404", "46405", "46407", "46408", "46409", "46410", "46411", "51501", "51502", "51503",
  "51510", "51526", "51542", "68002", "68005", "68007", "68008", "68010", "68016", "68022",
  "68023", "68028", "68034", "68046", "68056", "68059", "68064", "68068", "68069", "68073",
  "68101", "68102", "68103", "68104", "68105", "68106", "68107", "68108", "68109", "68110",
  "68111", "68112", "68113", "68114", "68116", "68117", "68118", "68119", "68122", "68123",
  "68124", "68127", "68128", "68130", "68131", "68132", "68133", "68134", "68135", "68136",
  "68137", "68138", "68139", "68142", "68144", "68145", "68147", "68152", "68154", "68157",
  "68164", "68172", "68175", "68176", "68178", "68179", "68180", "68182", "68183", "68197",
  "68198", "83605", "83616", "83634", "83642", "83644", "83646", "83651", "83652", "83653",
  "83669", "83680", "83686", "83687", "83701", "83702", "83703", "83704", "83705", "83706",
  "83707", "83708", "83709", "83711", "83712", "83713", "83714", "83715", "83717", "83719",
  "83720", "83722", "83724", "83725", "83728", "83729", "83732", "83735", "83756", "83799",
] as const;
